import { memo } from 'react'
import { AngleIcon } from '../../../../components/Icons'

interface BackBtnProps {
  onClick: () => void
}

const BackBtn: React.FC<BackBtnProps> = memo(({ onClick }) => {
  return (
    <button
      data-testid="back-btn"
      className="w-10 mr-2 h-10  z-20 flex items-center justify-center text-white font-medium tc-mv-logged-user tc-mv-blur align-middle rounded-full border-0 transition-all duration-300 absolute top-4 left-4"
      onClick={onClick}
    >
      <AngleIcon />
    </button>
  )
})

export { BackBtn }
